import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-fontawesome-icons',
  templateUrl: './fontawesome-icons.component.html',
  styleUrl: './fontawesome-icons.component.scss',
  standalone: false
})
export class FontawesomeIconsComponent implements AfterViewInit {

  @Output() selectedIcon = new EventEmitter<string>();

  @Input() height = 300;

  icons: string[] = [];

  prefix = 'fas';

  search: string = '';

  filterIcons: string[] = [];
  fontawesomeValue: string;
  fontawesomeIconClasses: string;

  constructor(private cdr: ChangeDetectorRef) {}
  

  ngAfterViewInit(): void {
    this.icons = this.getFontAwesomeClasses();
    this.filterIcons = this.icons;
    this.cdr.detectChanges();
  }

  getFontAwesomeClasses(): string[] {
    const classes = new Set<string>();

    // ignore empty classes
    const blacklist = [
      /^brands$/,
      /^classic$/,
      /^duotone$/,
      /^light$/,
      /^regular$/,
      /^sharp$/,
      /^sharp-duotone$/,
      /^solid$/,
      /^thin$/,
      /^2xs$/,
      /^2xl$/,
      /^beat-fade$/,
      /^spin-reverse$/,
      /^spin-pulse$/,
      /^xs$/,
      /^sm$/,
      /^lg$/,
      /^xl$/,
      /^\d+x$/,
      /^fw$/,
      /^ul$/,
      /^li$/,
      /^border$/,
      /^pull-/,
      /^inverse$/,
      /^spin$/,
      /^pulse$/,
      /^bounce$/,
      /^shake$/,
      /^fade$/,
      /^beat$/,
      /^flip/,
      /^rotate/,
      /^stack/,
      /^layers/,
      /^swap-/
    ];

    function isUtility(name: string): boolean {
      return blacklist.some(rx => rx.test(name));
    }

    for (const sheet of Array.from(document.styleSheets)) {
      try {
        for (const rule of Array.from((sheet as CSSStyleSheet).cssRules || [])) {
          const selector = (rule as CSSStyleRule).selectorText;
          if (selector && selector.startsWith('.fa-')) {
            const match = selector.match(/\.fa-([a-z0-9-]+)/i);
            if (match) {
              const iconName = match[1];
              if (!isUtility(iconName)) {
                classes.add(iconName);
              }
            }
          }
        }
      } catch {
        
      }
    }

    return Array.from(classes).sort();
  }

  searchIcons(search: string): void {
    if (!search || search.trim() === '') {
      // Se a busca estiver vazia, restaura a lista completa de ícones
      this.filterIcons = [...this.icons];
    } else {
      // Filtra os ícones com base no texto de busca (case-insensitive)
      const searchTerm = search.trim().toLowerCase();
      this.filterIcons = this.icons.filter(icon => icon.toLowerCase().includes(searchTerm));
    }
  }

  fontawesomeChange(icon){
    const regex = /class\s*=\s*"([^"]+)"/i;
    const match = icon.match(regex);
    this.fontawesomeIconClasses = match && match[1] ? match[1].trim() : ''

  }

  pickIcon(icon){
    this.selectedIcon.emit(`${this.prefix} fa-${icon}`);
  }
  
  pickFontawesomeIcon(){
    console.log('fontawesomeIconClasses', this.fontawesomeIconClasses);
     this.selectedIcon.emit(this.fontawesomeIconClasses);
  }
}
